function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DesktopOutlinedSvg from '@ant-design/icons-svg/lib/asn/DesktopOutlined';
import AntdIcon from "../components/AntdIcon";
const DesktopOutlined = (props, ref) => /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
  ref: ref,
  icon: DesktopOutlinedSvg
}));

/**![desktop](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNDBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjQ5NmMwIDE3LjcgMTQuMyAzMiAzMiAzMmgzODB2MTEySDMwNGMtOC44IDAtMTYgNy4yLTE2IDE2djQ4YzAgNC40IDMuNiA4IDggOGg0MzJjNC40IDAgOC0zLjYgOC04di00OGMwLTguOC03LjItMTYtMTYtMTZINTQ4VjcwMGgzODBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTcyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNDg4SDEzNlYyMTJoNzUydjQxNnoiIC8+PC9zdmc+) */
const RefIcon = /*#__PURE__*/React.forwardRef(DesktopOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DesktopOutlined';
}
export default RefIcon;